import React from "react";
import { useState, useRef } from "react";
// import image from "../img/logo.svg"
import google from "../img/google.png";
import DateTimePicker from "react-datetime-picker";
import GoogleAuth from "./../GoogleAuth";
import AWS from "aws-sdk";
import CreateMeet from "./../CreateMeet";
import AutoComplete, {
  usePlacesWidget,
  onPlaceSelected,
} from "react-google-autocomplete";
import AnyInput from "react-google-autocomplete";
AWS.config.update({
  accessKeyId: "AKIAWZB5KF6EBGT3RIHI",
  secretAccessKey: "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",
  region: "us-west-2",
});

function Landing() {
  const [start, setStart] = useState("");
  const [start1, setStart1] = useState("");
  const [start2, setStart2] = useState("");
  const [end, setEnd] = useState("");
  const [Status, setStatus] = React.useState("");
  const [userdata, setUserdata] = useState("");
  const [continue1, setContinue1] = useState(false);
  const [continue2, setContinue2] = useState(false);
  const [eventName, setEventName] = useState("");
  const [eventDescription, setEventDescription] = useState("");
  const [personalfirstname, setPersonalfirstname] = useState("");
  const [personallastname, setPersonallastname] = useState("");
  const [personalemail, setPersonalemail] = useState("");
  const [personalphone, setPersonalphone] = useState("");
  const [showgmeetlink, setShowgmeetlink] = React.useState("");
  const [location, setLoaction] = useState("");
  const [showemailoption, setShowemailoption] = React.useState(false);
  const [sentRequest, setSentRequest] = React.useState(false);
  const [dateTimeInputs, setDateTimeInputs] = useState([{ id: 1, value: "" }]);
  const meetLinkInputRef = useRef(null);

  const [errors, setErrors] = useState({});

  const validateForm = () => {
    let formErrors = {};
    if (!eventName) formErrors.eventName = "Meeting title is required";
    // if (!start && !start1 && !start2) formErrors.start = 'At least one Date Time is required';
    // if (!email) formErrors.email = 'Email is required';
    setErrors(formErrors);
    return Object.keys(formErrors).length === 0;
  };

  // Function to handle changes in input values
  const handleInputChange = (id, value) => {
    const newInputs = dateTimeInputs.map((input) =>
      input.id === id ? { ...input, value: value } : input
    );
    setDateTimeInputs(newInputs);
  };

  // Function to add a new date-time input
  const addDateTimeInput = () => {
    const newId = dateTimeInputs.length + 1;
    setDateTimeInputs([...dateTimeInputs, { id: newId, value: "" }]);
  };

  function showmeetlink(link) {
    console.log(link, "Meet link");
    setShowgmeetlink(link);
  }

  function showemailoptionnow(data = "") {
    console.log(data, "show data link");
    setShowemailoption(data);
  }

  function setUserdatanow(data = "") {
    console.log(data, "User data");
    setUserdata(data);
  }

  function copyToClipboard() {
    if (meetLinkInputRef.current) {
      meetLinkInputRef.current.select();
      document.execCommand("copy");
      alert("Meet link copied to clipboard");
    }
  }

  function continuethis(e) {
    e.preventDefault();
    if (validateForm()) {
      setContinue1(true);
    }
  }
  function formatDateTime(dateTime) {
    const date = new Date(dateTime);
    return date.toISOString();
  }
  const showformatDate = (dateString) => {
    return dateString.replace("T", " ");
  };
  function formatDate(dateString) {
    const date = new Date(dateString);

    const day = date.getDate();
    const month = date.toLocaleString("default", { month: "short" });
    const year = date.getFullYear();
    const hours = date.getHours().toString().padStart(2, "0");
    const minutes = date.getMinutes().toString().padStart(2, "0");

    return `${day} ${month} ${year} ${hours}:${minutes}`;
  }

  const sendEmail = () => {
    // console.log(userdata);
    const startdate = JSON.stringify(dateTimeInputs);
    setSentRequest(true);
    const baseemail = encodeURIComponent(personalemail);
    const baseUrl = "https://schedulemeet.vercel.app/schedulemeeting";
    const encodedename = encodeURIComponent(eventName);
    const encodedeedisp = eventDescription
      ? encodeURIComponent(eventDescription)
      : "";
    const encodedFirst =
      dateTimeInputs.length > 0 ? encodeURIComponent(startdate) : "";
    // const encodedSecond = start1 ? encodeURIComponent(start1) : "";
    // const encodedThird = start2 ? encodeURIComponent(start2) : "";
    const baselocation = encodeURIComponent(location);
    const facetoface = encodeURIComponent("facetoface");

    let actionUrl = `${baseUrl}?eventname=${encodedename}&email=${baseemail}&location=${baselocation}&facetoface=${facetoface}`;

    if (encodedFirst) {
      actionUrl += `&first=${encodedFirst}`;
    }
    if (encodedeedisp) {
      actionUrl += `&eventdesp=${encodedeedisp}`;
    }

    const meetingDatesHtml =
      dateTimeInputs.length > 0
        ? dateTimeInputs
            .map(
              (data) =>
                `<p style="margin-bottom:4px; margin-top:0px;font-size:16px;"><b>Meeting Date:</b> ${formatDate(
                  data.value
                )}</p>`
            )
            .join("")
        : "";
    let sendto = "avinash20802bala@gmail.com";
    let usersendto = personalemail ? personalemail : "";
    var subjectdata = "New Message for meeting";
    var usersubjectdata = "New Message for meeting";
    var messagedata = `
     <html>
     <head>
       <meta charset="UTF-8">
       <meta name="viewport" content="width=device-width, initial-scale=1.0">
     </head>
     <body style" padding: 20px;  font-family: Arial, sans-serif;margin: 0; padding: 0;background-color: #f4f4f4;">
       <div class="container" style=" width: 100%; max-width: 600px;margin: 0 auto; background-color: #ffffff;border-radius: 8px; overflow: hidden; box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);">
         <div class="header" style=" background-color:#007bff;color:#ffffff;padding:20px;text-align:center;">
           <h1>Face to Face Meeting Request Notification</h1>
         </div>
         <div class="body">
           <p style="font-size:16px;">Dear Mamdoh,</p>
           <p style="font-size:16px;">I hope this email finds you well. </p>
           <p style="font-size:16px;">I wanted to inform you that we have received a request for a Face to Face Meeting Notification meeting. Below are the details of the request: </p>

            ${meetingDatesHtml}
           <p style="font-size:16px;"><b>Firstname:</b> ${personalfirstname}</p>
           <p style="font-size:16px;"><b>Lastname:</b> ${personallastname}</p>
           <p style="font-size:16px;"><b>Email:</b> ${personalemail}</p>
           <p style="font-size:16px;"><b>Contact No:</b> ${personalphone}</p>
           <p style="font-size:16px;"><b>Meeting Location:</b> ${location}</p>
           <p style="font-size:16px;">To get started, please click the button below:</p>
           <a href=${actionUrl} class="button"style="color: #007bff; text-decoration: none;display: inline-block;padding: 10px 20px; margin: 10px 0; background-color: #007bff;color: #ffffff;
           text-align: center; border-radius: 5px;text-decoration: none;">Click Here</a>
           <p style="font-size:16px;">Please review the request and let me confirm your availability.</p>
           <p style="font-size:16px;">Thank you
           This is an automated email.</p>
         </div>
       </div>
     </body>
     </html>
     `;

    var usermessagedata = `
     <html>
     <head>
       <meta charset="UTF-8">
       <meta name="viewport" content="width=device-width, initial-scale=1.0">
     </head>
     <body style="padding:20px; font-family: Arial, sans-serif;margin: 0;padding: 0;background-color: #f4f4f4;">
       <div class="container" style="width: 100%; max-width: 600px; margin: 0 auto; background-color: #ffffff; border-radius: 8px; overflow: hidden;
       box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);">
         <div class="header" style="background-color: #007bff;color:#ffffff;padding:20px;
         text-align: center;">
           <h1>Confirmation of Face to Face Meeting Request Submission</h1>
         </div>
         <div class="body">
           <p style="font-size:16px;">Dear ${
             personalfirstname ? personalfirstname : ""
           }</p>
           <p style="font-size:16px;">Thank you for your request to schedule a Face to Face Meeting. </p>
           <p style="font-size:16px;">We have successfully received your submission and are in the process of reviewing the details.: </p>
           <p style="font-size:16px;">Here is a summary of your request:</p>
            ${meetingDatesHtml}
           <p style="font-size:16px;"><b>Purpose of Meeting:</b> ${
             eventDescription ? eventDescription : ""
           }</p>
           <p style="font-size:16px;"><b>Meeting Location :</b> ${location}</p>
           <p style="font-size:16px;">We will get back to you shortly with a confirmation of the meeting or any additional information we might need.</p>
           <p style="font-size:16px;">Thank you for your patience. We look forward to connecting with you soon.</p>
           <p style="font-size:16px;">Best regards,Mamdoh.</p>
         </div>
       </div>
     </body>
     </html>
     `;
    // Create an instance of the SES service
    const ses = new AWS.SES({ apiVersion: "2023-08-09" });
    const params = {
      Destination: {
        ToAddresses: [sendto], // Replace with the recipient's email address
      },
      Message: {
        Body: {
          Html: {
            Data: messagedata, // Email content
          },
        },
        Subject: {
          Data: subjectdata, // Email subject
        },
      },
      Source: "admin@brokeragentbase.com", // Replace with your verified sender email address
    };
    const userparams = {
      Destination: {
        ToAddresses: [usersendto], // Replace with the recipient's email address
      },
      Message: {
        Body: {
          Html: {
            Data: usermessagedata, // Email content
          },
        },
        Subject: {
          Data: usersubjectdata, // Email subject
        },
      },
      Source: "admin@brokeragentbase.com", // Replace with your verified sender email address
    };

    // Send the email
    ses.sendEmail(params, (err, data) => {
      if (err) {
        console.error("Error sending email:", err);
      } else {
        console.log("Email sent successfully:", data);
        setSentRequest(false);
        showmeetlink("link");
      }
    });
    ses.sendEmail(userparams, (err, data) => {
      if (err) {
        console.error("Error sending email:", err);
      } else {
        console.log("Email sent successfully:", data);
        setSentRequest(false);
        showmeetlink("link");
      }
    });
  };

  return (
    <>
      {/***start****/}
      <section className="schedule_meet">
        <div className="container">
          <div className="row">
            <div className="form_v1_view">
              <div className="wrapperlanding">
                {showgmeetlink ? (
                  <div className="float-left w-100 text-center d-flex align-items-start justify-content-between">
                    <div className="float-left w-100 text-center">
                      <h2>
                        Successfully sent your <br />
                        meeting request!
                      </h2>
                      <p className="">
                        Avinash has received your <br />
                        meeting suggestion, expect an
                        <br /> answer in your inbox.
                      </p>
                      <p className="mb-1">
                        <small>Email used:{personalemail}</small>
                      </p>
                      {/* <p className="mb-0"><small><a href="/">Change Info</a></small></p> */}
                      <p className="mb-0">
                        <small>
                          <a href="/">Schedule New Meeting</a>
                        </small>
                      </p>
                    </div>
                  </div>
                ) : (
                  <>
                    <div className="d-flex align-items-start justify-content-between">
                      <h2>Schedule your meet with Avinash</h2>
                      <img
                        className="img-fluid g_oogle"
                        src={userdata?.imageUrl ?? google}
                        referrerPolicy="no-referrer"
                      />
                    </div>
                    <ul class="nav nav-tabs" role="tablist">
                      <li class="nav-item me-0 w-50">
                        <a
                          href="#home1"
                          class="nav-link active text-center"
                          data-bs-toggle="tab"
                          role="tab"
                        >
                          Virtual
                        </a>
                      </li>
                      <li class="nav-item me-0 w-50">
                        <a
                          href="#profile1"
                          class="nav-link text-center"
                          data-bs-toggle="tab"
                          role="tab"
                        >
                          Face to Face
                        </a>
                      </li>
                    </ul>
                    <div class="tab-content">
                      <div
                        class="tab-pane fade show active"
                        id="home1"
                        role="tabpanel"
                      >
                        <div class="needs-validation">
                          <div class="row">
                            <div class="col-md-12 mb-0">
                              <div className="form_group mb-3">
                                <label
                                  class="form-label"
                                  for="validationCustom01"
                                >
                                  Meeting Info
                                </label>
                                <input
                                  class="form-control icon_v1"
                                  type="text"
                                  placeholder="Meeting Title"
                                  onChange={(e) => setEventName(e.target.value)}
                                  value={eventName}
                                  required
                                />
                                {errors.eventName && (
                                  <p className="text-danger">
                                    {errors.eventName}
                                  </p>
                                )}
                                <i class="h2 fi-chat-left opacity-80"></i>
                              </div>
                              <div className="form_group">
                                <textarea
                                  class="form-control"
                                  type="text"
                                  placeholder="Short Meeting Description"
                                  onChange={(e) =>
                                    setEventDescription(e.target.value)
                                  }
                                  value={eventDescription}
                                />
                                <p className="mt-1">
                                  <small>Optional</small>
                                </p>
                              </div>
                            </div>

                            {dateTimeInputs.map((input) => (
                              <div key={input.id} className="col-md-12 mb-3">
                                <label
                                  className="form-label"
                                  htmlFor={`datetime-${input.id}`}
                                >
                                  Time & Date
                                </label>
                                <input
                                  className="form-control"
                                  type="datetime-local"
                                  id={`datetime-${input.id}`}
                                  placeholder="Suggest a Time & Date"
                                  name={`startDate-${input.id}`}
                                  onChange={(e) =>
                                    handleInputChange(input.id, e.target.value)
                                  }
                                  value={input.value}
                                  style={{
                                    border: "1px solid #00000026",
                                  }}
                                  data-datepicker-options='{"altInput": true, "altFormat": "F j, Y", "dateFormat": "Y-m-d"}'
                                />
                                {errors[`start-${input.id}`] && (
                                  <p className="text-danger">
                                    {errors[`start-${input.id}`]}
                                  </p>
                                )}
                              </div>
                            ))}
                            <p
                              type="button"
                              onClick={addDateTimeInput}
                              className=""
                            >
                              Add Another Date & Time
                            </p>
                          </div>
                          {continue1 ? (
                            <>
                              <GoogleAuth
                                showemailoptionnow={showemailoptionnow}
                                setUserdatanow={setUserdatanow}
                              />
                              {showgmeetlink && showgmeetlink != "" ? (
                                <div class="col-md-12 mb-3">
                                  <div className="form_group">
                                    <label
                                      class="form-label"
                                      for="validationCustomUsername"
                                    >
                                      Meeting
                                    </label>
                                    <input
                                      className="form-control icon_v1"
                                      type="text"
                                      placeholder="Google Meet"
                                      value={showgmeetlink}
                                      ref={meetLinkInputRef}
                                      readOnly
                                    />
                                    <i
                                      className="h2 fa fa-clone opacity-80"
                                      onClick={copyToClipboard}
                                    ></i>
                                  </div>
                                </div>
                              ) : (
                                <>
                                  {showemailoption &&
                                  showemailoption === true ? (
                                    <CreateMeet
                                      eventName={eventName}
                                      eventDescription={eventDescription}
                                      start={
                                        dateTimeInputs
                                          ? JSON.stringify(dateTimeInputs)
                                          : ""
                                      }
                                      end={
                                        dateTimeInputs
                                          ? JSON.stringify(dateTimeInputs)
                                          : ""
                                      }
                                      showmeetlink={showmeetlink}
                                      data={userdata}
                                    />
                                  ) : (
                                    <></>
                                  )}
                                </>
                              )}
                            </>
                          ) : (
                            <div>
                              <button
                                class="btn btn-primary"
                                type="submit"
                                onClick={(e) =>continuethis(e)}
                              >
                                Continue
                              </button>
                            </div>
                          )}
                        </div>
                      </div>

                      <div class="tab-pane fade" id="profile1" role="tabpanel">
                        <div class="needs-validation">
                          <div class="row">
                            <div class="col-md-12 mb-0">
                              <div className="form_group mb-3">
                                <label
                                  class="form-label"
                                  for="validationCustom01"
                                >
                                  Meeting Info
                                </label>
                                <input
                                  class="form-control icon_v1"
                                  type="text"
                                  placeholder="Meeting Title"
                                  onChange={(e) => setEventName(e.target.value)}
                                  value={eventName}
                                  required
                                />
                                {errors.eventName && (
                                  <p className="text-danger">
                                    {errors.eventName}
                                  </p>
                                )}
                                <i class="h2 fi-chat-left opacity-80"></i>
                              </div>
                              <div className="form_group">
                                <textarea
                                  class="form-control"
                                  type="text"
                                  placeholder="Short Meeting Description"
                                  onChange={(e) =>
                                    setEventDescription(e.target.value)
                                  }
                                  value={eventDescription}
                                />
                                {/* {errors.eventDescription && <p className="text-danger">{errors.eventDescription}</p>} */}
                                <p className="mt-1">
                                  <small>Optional</small>
                                </p>
                              </div>
                            </div>
                            {dateTimeInputs.map((input) => (
                              <div key={input.id} className="col-md-12 mb-3">
                                <label
                                  className="form-label"
                                  htmlFor={`datetime-${input.id}`}
                                >
                                  Time & Date
                                </label>
                                <input
                                  className="form-control"
                                  type="datetime-local"
                                  id={`datetime-${input.id}`}
                                  placeholder="Suggest a Time & Date"
                                  name={`startDate-${input.id}`}
                                  onChange={(e) =>
                                    handleInputChange(input.id, e.target.value)
                                  }
                                  value={input.value}
                                  style={{
                                    border: "1px solid #00000026",
                                  }}
                                  data-datepicker-options='{"altInput": true, "altFormat": "F j, Y", "dateFormat": "Y-m-d"}'
                                />
                                {errors[`start-${input.id}`] && (
                                  <p className="text-danger">
                                    {errors[`start-${input.id}`]}
                                  </p>
                                )}
                              </div>
                            ))}
                            <p
                              type="button"
                              onClick={addDateTimeInput}
                              className=""
                            >
                              Add Another Date & Time
                            </p>
                            {console.log(dateTimeInputs, "newInputs")}
                            
                            <div class="col-md-12 mb-3">
                              <div className="form_group">
                                <label
                                  class="form-label"
                                  for="validationCustomUsername"
                                >
                                  Location
                                </label>
                                <input
                                  class="form-control icon_v1"
                                  type="text"
                                  placeholder="Enter Location"
                                  value={location}
                                  onChange={(e) => setLoaction(e.target.value)}
                                />
                                <i class="h2 fi-map-pin opacity-80"></i>
                              </div>
                            </div>
                            {/* Personal  */}
                            <div class="row">
                              <div class="col-md-12 mb-0">
                                <div className="form_group">
                                  <label
                                    class="form-label"
                                    for="validationCustomUsername"
                                  >
                                    Personal Information
                                  </label>
                                </div>
                              </div>
                              <div class="col-md-6 mb-3">
                                <input
                                  class="form-control"
                                  type="text"
                                  placeholder="First Name"
                                  onChange={(e) =>
                                    setPersonalfirstname(e.target.value)
                                  }
                                  value={personalfirstname}
                                />
                              </div>
                              <div class="col-md-6 mb-3">
                                <input
                                  class="form-control"
                                  type="text"
                                  placeholder="Last Name"
                                  onChange={(e) =>
                                    setPersonallastname(e.target.value)
                                  }
                                  value={personallastname}
                                />
                              </div>
                              <div class="col-md-12 mb-3">
                                <div className="form_group v1">
                                  <input
                                    class="form-control icon_v1"
                                    type="text"
                                    id=""
                                    placeholder="Email"
                                    onChange={(e) =>
                                      setPersonalemail(e.target.value)
                                    }
                                    value={personalemail}
                                  />
                                  <i class="h2 fa fa-envelope opacity-80"></i>
                                </div>
                              </div>
                              <div class="col-md-12 mb-3">
                                <div className="form_group v1">
                                  <input
                                    class="form-control icon_v1"
                                    type="text"
                                    id=""
                                    placeholder="0000-0000-00"
                                    onChange={(e) =>
                                      setPersonalphone(e.target.value)
                                    }
                                    value={personalphone}
                                  />
                                  <i class="h2 fa fa-phone opacity-80"></i>
                                </div>
                              </div>
                            </div>
                            {/* Personal  end*/}
                          </div>
                          {continue1 ? (
                            <>
                              <GoogleAuth
                                showemailoptionnow={showemailoptionnow}
                                setUserdatanow={setUserdatanow}
                              />
                              {showgmeetlink && showgmeetlink != "" ? (
                                <div class="col-md-12 mb-3">
                                  <div className="form_group">
                                    <label
                                      class="form-label"
                                      for="validationCustomUsername"
                                    >
                                      Meeting
                                    </label>
                                    <input
                                      className="form-control icon_v1"
                                      type="text"
                                      placeholder="Google Meet"
                                      value={showgmeetlink}
                                      ref={meetLinkInputRef}
                                      readOnly
                                    />
                                    <i
                                      className="h2 fa fa-clone opacity-80"
                                      onClick={copyToClipboard}
                                    ></i>
                                  </div>
                                </div>
                              ) : (
                                <>
                                  {showemailoption &&
                                  showemailoption === true ? (
                                    <CreateMeet
                                      eventName={eventName}
                                      eventDescription={eventDescription}
                                      start={start}
                                      end={start}
                                      showmeetlink={showmeetlink}
                                    />
                                  ) : (
                                    <></>
                                  )}
                                </>
                              )}
                            </>
                          ) : (
                            <div>
                              <button
                                class="btn btn-primary"
                                type="submit"
                                onClick={(e) => sendEmail(e)}
                              >
                                {sentRequest ? "Please Wait" : "Send Request"}
                              </button>
                            </div>
                          )}
                        </div>
                      </div>
                    </div>
                  </>
                )}
              </div>
            </div>
          </div>
        </div>
      </section>
      {/***end****/}
    </>
  );
}

export default Landing;
